$ = window.jQuery;

class Search {

    // 1. describe and create
    constructor() {
        this.formSelector = $('#searchform');
        this.resultsContainer = $('.resolved-listings');
        this.currentPage = search.current_page;
        this.loadmoreContainer = $('.loadmore-listings');
        this.loadMore = $('.loadmore-btn');
        this.pagination = $('.listings-pagination');
        this.searchReset = $('.search-reset-button');
        this.page = $('.resolved-listings').data('page');
        this.events();
        this.loadmore();
    }

    events(){
        $(document).on('click',  '.search-reset-button', this.resetQuery.bind(this) );
        $(document).on('submit', '#searchform', this.init.bind(this));
    }

    init(event) {
        event.preventDefault();
        const self = this;
        const searchfield = self.formSelector.find('#searchfield').val();
        if(searchfield.length != 0 ){
            self.pagination.hide();
        } else {
            self.pagination.show();
        }
        self.resultsContainer.empty();
        const yearAfter = $('.resolved-listings').data('after') != undefined ? $('.resolved-listings').data('after') : '';
        const yearBefore = $('.resolved-listings').data('before') != undefined ? $('.resolved-listings').data('before') : '';
        const data = {
            action: 'job_listing_search',
            search_query: searchfield,
            security: search.nonce,
            paged: self.currentPage,
            pagenow: self.page,
            afterYear: yearAfter,
            yearBefore: yearBefore
        }
        $.ajax({
            url: search.ajaxurl,
            type: 'POST',
            data: data,
            success: function (response) {
                if(response != 'No posts'){
                    self.displayResults(response);
                } else {
                    self.noResults();
                }
            },
            error: function (xhr, status, error) {
                console.log('Error:', xhr);
            }
        });
    }

    displayResults(response, action = null) {
        this.scrollTop();
        $('.loadmore-btn-search').hide();
        if (!(response.length < 9) || (action != 'loadmore')) {
            if(this.formSelector.find('#searchfield').val().length != 0){
                const newLoadmore = '<div class="loadmore-btn-search">Încarca mai multe listari</div>';
                this.loadmoreContainer.append(newLoadmore);
            }
        }
        var placeholderImg = $('#resolved-listing-form').data('placeholder');

        for (var i = 0; i < response.length; i++) {
            var html = '<div class="grid-list-item">';
            html += '<a href="' + response[i].permalink + '">';
            html += '<div class="img">';
            html += '<div class="overlay"></div>';
            if (response[i].mainImage) {
                html += '<img src="' + response[i].mainImage + '">';
            } else {
                html += '<img src="' + placeholderImg + '">';
            }
            html += '<div class="listing-localization">';
            if (response[i].judet != '') {
                html += '<p class="listing-judet">' + response[i].judet + '</p>';
            }
            if (response[i].regiune != '') {
                html += '<p class="listing-judet">' + response[i].regiune + '</p>';
            }
            html += '</div>';
            html += '<div class="listing-title">';
            html += '<h5>' + response[i].title + '</h5>';
            html += '</div>';
            html += '</div>';
            html += '<div class="status-bar">';
            html += '<p>Alerta rezolvata de</p>';
            html += '<div class="sponsor">';
            if (response[i].sponsorLogoUrl) {
                html += '<img class="sponsor-logo" src="' + response[i].sponsorLogoUrl + '" alt="">';
            } else {
                html += '<div class="cleint-name">Persoana Fizica</div>';
            }
            html += '</div>';
            html += '</div>';
            html += '</a>';
            html += '</div>';
            this.resultsContainer.append(html);
        }
    }

    loadmore(){
        const self = this;
        $(document).on('click', '.loadmore-btn-search', function(){
            const searchQuery = $(this).find('#searchfield').val();
            const yearAfter = $('.resolved-listings').data('after') != undefined ? $('.resolved-listings').data('after') : '';
            const yearBefore = $('.resolved-listings').data('before') != undefined ? $('.resolved-listings').data('before') : '';
            self.currentPage++;
            const data = {
                action: 'job_listing_search',
                search_query: searchQuery,
                security: search.nonce,
                paged: self.currentPage,
                pagenow: self.page,
                afterYear: yearAfter,
                yearBefore: yearBefore
            }
            $.ajax({
                url: search.ajaxurl,
                type: 'POST',
                data: data,
                success: function (response) {
                    console.log(response);
                    if(response != 'No posts'){
                        self.displayResults(response, 'loadmore');
                    } else {
                        $('.loadmore-btn-search').hide();
                    }
                },
                error: function (xhr, status, error) {
                    console.log('Error:', xhr);
                }
            });
        });
    }

    scrollTop() {
        $('html, body').animate({
            scrollTop: '+=500px'
        }, 500);
    }

    noResults(){
        this.resultsContainer.empty();
        this.resultsContainer.append(`
        <div class="no-results">
            <p>Nici un rezultat</p>
            <div class="search-reset-button">
                <p>Reseteaza cautarea</p>
            </div>
        </div>
        `);
    }

    resetQuery(){
        this.resultsContainer.empty();
        $('.loadmore-btn-search').hide();
        this.formSelector.find('#searchfield').val('');
        this.formSelector.submit();
    }

}

export default Search;
